import Layout from 'features/shared/Layout';
import ChallengesIndex from 'features/challenges/Index';

export default function Index({ challenges }) {
  return (
    <Layout
      description="Browse through the front-end coding challenges on Frontend Mentor. Find interesting projects to practice your HTML, CSS and JavaScript"
      image="https://res.cloudinary.com/dz209s6jk/image/upload/v1585172856/Meta/meta-challenges.png"
      title="Frontend Mentor | Challenges"
      url="https://www.frontendmentor.io/challenges"
    >
      <ChallengesIndex challenges={challenges} />
    </Layout>
  );
}

export async function getStaticProps() {
  const data = [];
  const pages = [1, 2, 3];

  for (const page of pages) {
    const res = await fetch(
      `${process.env.NEXT_PUBLIC_REST_API_URL}/v3/challenges?page=${page}&size=40`
    );

    const body = await res.json();
    data.push(...body.data);
  }

  return { props: { challenges: data }, revalidate: 60 * 60 * 24 };
}
